module.exports = "/static/assets/adb3d064c06ba450a7c6da5ca21c7527.png";